import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { GlobalHttpClient } from '../global.http.client';
import { ISearchService } from './search.service';
import { Observable } from 'rxjs';
import { CompetitorDto, CompetitorAwardsSearchModel, AwardDto, CurrentCompetitorsSearchModel } from '../models/competitors/competitor.models';
import { IPage } from '../models/common/paging';
import { HttpEvent, HttpRequest } from '@angular/common/http';
import { Configuration } from '../configuration';

@Injectable()
export class CompetitorAwardsService extends BaseService implements ISearchService<CompetitorAwardsSearchModel, AwardDto> {
    constructor(http: GlobalHttpClient, private config: Configuration) {
        super(http);
    }

    search(request: CompetitorAwardsSearchModel): Observable<IPage<AwardDto>> {
        return this.http.post<IPage<AwardDto>>('competitors/getAwardsForSupplier', request);
    }

    getAwardsForSupplier() {
        return this.http.get(`competitors/getAwardsForSupplier`);
    }

    getCompetitors() {
        return this.http.get<string[]>('competitors/getCompetitorsList');
    }

    downloadCsv(supplierId: number) {
        var url = `${this.config.routing.api.baseUrl}/competitors/getCompetitorsCsv/${supplierId}`;
        window.location.href = url;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/competitor.awards.service.ts